<template>
    <div class="filter-component">
      <template v-if="getFilterComponent === 'date'">
        <el-date-picker class="component-content"
          disabled
          style="width: 100%"
          type="date"
          placeholder="选择日期">
        </el-date-picker>
      </template>
      <template v-if="getFilterComponent === 'select'">
        <el-select
          class="component-content filter-select"
          :span="24"
          disabled
          value
          placeholder="请选择">
        </el-select>
      </template>
      <template v-if="getFilterComponent === 'input'">
        <el-input class="component-content" disabled></el-input>
      </template>
    </div>
</template>

<script>
export default {
  name: 'filter-component',
  props: ['filter'],
  mounted () {
    this.$emit('create', this)
  },
  destroyed () {
    this.$emit('destory', this)
  },
  computed: {
    getFilterComponent () {
      let type = this.filter.dataType
      if (type === 'enum') {
        return 'select'
      } else if (type.includes('date')) {
        return 'date'
      } else {
        return 'input'
      }
    }
  }
}
</script>

<style lang="scss">
  .filter-component {
    .component-content {
      input {
        height: 26px;
        line-height: 26px;
      }
    }
  }
  .filter-select{
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/report/design/filter-component.vue